import React, { useRef } from "react";
import "../styles/Contact.css";
import Footer from '../components/Footer';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const formRef = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      'service_400wfya',
      'template_rypu86n',
      formRef.current,
      'v4aVMss4HfBL-_7FT'
    )
    .then(() => {
      alert('Message sent successfully!');
      formRef.current.reset();
    }, () => {
      alert('Failed to send message. Please try again.');
    });
  };

  return (
    <div>
      <h2 className="contact-title">Contact</h2>
      <p className="contact-text">We’re eager to hear from you and assist with any inquiries or service requests you may have.</p>
      <div className="contact-section">
        <div className="contact-info">
          <h1>Get In Touch</h1>
          <p>
            Interested in <strong>AGR Consultant & Engineers</strong> services? Request an estimate today and discover how
            GratitudeTech can meet your electrical needs with precision and reliability.
          </p>
          <div className="contact-item">
            <div>
              <h2>Head Office</h2>
              <span>4R-17, Gandhi Kutir, Bhiwadi, Alwar, Rajasthan - 301019</span>
            </div>
          </div>
          <div className="contact-item">
            <div>
              <h2>Email</h2>
              <span>agrconsultant98@gmail.com</span>
            </div>
          </div>
          <div className="contact-item">
            <div>
              <h2>Phone</h2>
              <span>+91 9257112851</span>
            </div>
          </div>
        </div>
        <div className="contact-form">
          <p>
            Whether you have questions about <strong>AGR Consultant & Engineers</strong> services, need assistance with a
            project, or simply want to say hello, we’re here to help. Reach out to us today, and one of our friendly
            team members will get back to you as soon as possible.
          </p>
          <form ref={formRef} onSubmit={sendEmail}>
            <div className="row">
              <input type="text" name="first_name" placeholder="First Name" required />
              <input type="text" name="last_name" placeholder="Last Name" required />
            </div>
            <div className="row">
              <input type="email" name="email" placeholder="Email" required />
              <input type="text" name="phone" placeholder="Phone" required />
            </div>
            <textarea name="message" placeholder="Message" rows={5} required></textarea>
            <input type="hidden" name="subject" value="Received from the Web-Site" />
            <button type="submit">SEND MESSAGE</button>
          </form>
        </div>
      </div>
      <div><Footer /></div>
    </div>
  );
};

export default Contact;